module.exports = __webpack_public_path__ + "static/media/HilOffTradeBrand4.f4088749.png";